export enum DevelopmentServiceEndpoints {
    GetDevelopmentDetails = '/v1/development/{developmentSlug}',
}
